/**
 * Navigation helpers for Bond Palantir application
 * Provides centralized functions for navigating between Palantir and Dashboard views
 */

/**
 * Parse the current route and determine its type
 * @returns {Object} Route information with type and relevant parameters
 */
export function parseRoute(hash = window.location.hash) {
    if (!hash || hash === '#' || hash === '#/') {
        return { type: 'dashboard', mode: 'search' };
    }

    // Dashboard routes: #/u/<user-id> and #/u/<user-id>/home/<home-id>
    if (hash.startsWith('#/u/')) {
        const rest = hash.substring('#/u/'.length);
        const homeMarker = '/home/';
        const homeIdx = rest.indexOf(homeMarker);
        if (homeIdx !== -1) {
            const userId = decodeURIComponent(rest.substring(0, homeIdx));
            const homeId = decodeURIComponent(rest.substring(homeIdx + homeMarker.length));
            return { type: 'dashboard', mode: 'user', userId, homeId };
        }
        const userId = decodeURIComponent(rest);
        return { type: 'dashboard', mode: 'user', userId };
    }

    // Palantir routes
    if (hash.startsWith('#/palantir/')) {
        const bondId = hash.substring('#/palantir/'.length).split('/')[0];
        return { type: 'palantir', bondId, apiType: 'cloud', tab: 'livelog' };
    }

    // Mate debug mode
    if (hash.startsWith('#mate')) {
        return { type: 'mate' };
    }

    // Legacy Palantir routes (#cloud/livelog/BONDID or #local/tree/BONDID)
    const legacyMatch = hash.match(/^#([a-z]+)\/([a-z]+)\/([A-Z0-9]+)/);
    if (legacyMatch) {
        const [, apiType, tab, bondId] = legacyMatch;
        return { type: 'palantir', bondId, apiType, tab };
    }

    // Default to dashboard search for unrecognized patterns
    return { type: 'dashboard', mode: 'search' };
}
